import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";

import { Form, Button, App } from "antd";

import { verifyEmail } from "../api/verifyEmailAPI";
import { styles } from "../styles/verifyEmailStyles";

export default function ResetPasswordForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { message } = App.useApp();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Extract token directly from URL query parameters
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const { handleSubmit } = useForm();

  const onSubmit = async () => {
    if (!token) {
      message.error("Verify token is missing");
      return;
    }

    setIsSubmitting(true);
    try {
      await verifyEmail(token);
      message.success("Email verified successfully");
      navigate("/login");
    } catch (error: any) {
      message.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Form
      name="verifyEmailForm"
      onFinish={handleSubmit(onSubmit)}
      labelAlign="left"
      colon={false}
      layout="vertical"
    >
      <Form.Item>
        <Button
          style={styles.verifyEmailButton}
          type="primary"
          htmlType="submit"
          size="large"
          loading={isSubmitting}
          disabled={!token}
        >
          Verify Email
        </Button>
      </Form.Item>
    </Form>
  );
}
